import { Navigate } from 'react-router-dom';

const NotFoundRoute = () => <Navigate replace to="/" />; // FIXME: Do we actually want to do this? Maybe we should just show a 404 page, or just have the '/' component also used for catchall. That way the url won't be changed so if it's a typo the user can just correct it. And with 404 it's also much clearer feedback something has gone wrong.
export default NotFoundRoute;
